import React from "react";
import "./custom-datepicker.scss";
import DatePicker from "react-datepicker";
import CustomButton from "../CustomButton/CustomButton";

const addTwoDays = (date) => {
  const twoDays = 2 * 24 * 60 * 60 * 1000;
  return new Date(date.getTime() + twoDays);
};

const subtractTwoDays = (date) => {
  const twoDays = 2 * 24 * 60 * 60 * 1000;
  return new Date(date.getTime() - twoDays);
};

const CustomDatepicker = ({ selected, onChange, name, placeholder }) => {
  const ref = React.useRef();
  const mref = React.useRef();

  return (
    <>
      {/* Desktop version */}
      <div className="customDatePickerWidth show-desktop">
        <DatePicker
          ref={ref}
          name={name}
          className="custom-datepicker"
          showIcon
          dateFormat="MMMM d, yyyy "
          selected={selected}
          onChange={onChange}
          placeholderText={placeholder}
          enableTabLoop={false}
          header="Select Flight Date"
          formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
          showPopperArrow={false}
          shouldCloseOnSelect
          minDate={subtractTwoDays(new Date())}
          maxDate={addTwoDays(new Date())}
          popperModifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
            },
          }}
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64844 10.3318H20.3475M8.10109 7.54924V3.65234M15.8949 7.54924V3.65234M19.2341 5.87914H4.76184C4.46655 5.87914 4.18335 5.99645 3.97454 6.20525C3.76574 6.41405 3.64844 6.69725 3.64844 6.99254V19.239C3.64844 19.5343 3.76574 19.8175 3.97454 20.0263C4.18335 20.2351 4.46655 20.3524 4.76184 20.3524H19.2341C19.5294 20.3524 19.8126 20.2351 20.0214 20.0263C20.2302 19.8175 20.3475 19.5343 20.3475 19.239V6.99254C20.3475 6.69725 20.2302 6.41405 20.0214 6.20525C19.8126 5.99645 19.5294 5.87914 19.2341 5.87914Z"
                stroke="#212529"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.27054 13.67C7.19671 13.67 7.12591 13.6407 7.07371 13.5885C7.02151 13.5363 6.99219 13.4655 6.99219 13.3916C6.99219 13.3178 7.02151 13.247 7.07371 13.1948C7.12591 13.1426 7.19671 13.1133 7.27054 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.26562 13.67C7.33945 13.67 7.41025 13.6407 7.46245 13.5885C7.51465 13.5363 7.54398 13.4655 7.54398 13.3916C7.54398 13.3178 7.51465 13.247 7.46245 13.1948C7.41025 13.1426 7.33945 13.1133 7.26562 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.27054 17.5645C7.19671 17.5645 7.12591 17.5352 7.07371 17.483C7.02151 17.4308 6.99219 17.36 6.99219 17.2862C6.99219 17.2123 7.02151 17.1415 7.07371 17.0893C7.12591 17.0371 7.19671 17.0078 7.27054 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.26562 17.5645C7.33945 17.5645 7.41025 17.5352 7.46245 17.483C7.51465 17.4308 7.54398 17.36 7.54398 17.2862C7.54398 17.2123 7.51465 17.1415 7.46245 17.0893C7.41025 17.0371 7.33945 17.0078 7.26562 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M11.9971 13.67C11.9233 13.67 11.8525 13.6407 11.8003 13.5885C11.7481 13.5363 11.7188 13.4655 11.7188 13.3916C11.7188 13.3178 11.7481 13.247 11.8003 13.1948C11.8525 13.1426 11.9233 13.1133 11.9971 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M12 13.6701C12.0738 13.6701 12.1446 13.6408 12.1968 13.5886C12.249 13.5364 12.2784 13.4656 12.2784 13.3918C12.2784 13.3179 12.249 13.2471 12.1968 13.1949C12.1446 13.1427 12.0738 13.1134 12 13.1134"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M11.9971 17.5645C11.9233 17.5645 11.8525 17.5352 11.8003 17.483C11.7481 17.4308 11.7188 17.36 11.7188 17.2862C11.7188 17.2123 11.7481 17.1415 11.8003 17.0893C11.8525 17.0371 11.9233 17.0078 11.9971 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M12 17.5645C12.0738 17.5645 12.1446 17.5352 12.1968 17.483C12.249 17.4308 12.2784 17.36 12.2784 17.2862C12.2784 17.2123 12.249 17.1415 12.1968 17.0893C12.1446 17.0371 12.0738 17.0078 12 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7315 13.67C16.6577 13.67 16.5869 13.6407 16.5347 13.5885C16.4825 13.5363 16.4531 13.4655 16.4531 13.3916C16.4531 13.3178 16.4825 13.247 16.5347 13.1948C16.5869 13.1426 16.6577 13.1133 16.7315 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7344 13.67C16.8082 13.67 16.879 13.6407 16.9312 13.5885C16.9834 13.5363 17.0127 13.4655 17.0127 13.3916C17.0127 13.3178 16.9834 13.247 16.9312 13.1948C16.879 13.1426 16.8082 13.1133 16.7344 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7315 17.5645C16.6577 17.5645 16.5869 17.5352 16.5347 17.483C16.4825 17.4308 16.4531 17.36 16.4531 17.2862C16.4531 17.2123 16.4825 17.1415 16.5347 17.0893C16.5869 17.0371 16.6577 17.0078 16.7315 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7344 17.5645C16.8082 17.5645 16.879 17.5352 16.9312 17.483C16.9834 17.4308 17.0127 17.36 17.0127 17.2862C17.0127 17.2123 16.9834 17.1415 16.9312 17.0893C16.879 17.0371 16.8082 17.0078 16.7344 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
            </svg>
          }
        >
          <div className="action-buttons">
            <CustomButton
              onClick={() => {
                onChange(new Date());
                ref.current.setOpen(false);
              }}
              name="reset"
            />
            <CustomButton
              classnames="primary"
              onClick={() => {
                onChange(selected);
                ref.current.setOpen(false);
              }}
              name="done"
            />
          </div>
        </DatePicker>
      </div>

      {/* Mobile version */}
      <div className="customDatePickerWidth show-mobile">
        <DatePicker
          ref={mref}
          name={name}
          className="custom-datepicker"
          showIcon
          dateFormat="MMMM d, yyyy "
          selected={selected}
          onChange={onChange}
          placeholderText={placeholder}
          enableTabLoop={false}
          header="Select Flight Date"
          formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
          showPopperArrow={false}
          shouldCloseOnSelect={false}
          minDate={subtractTwoDays(new Date())}
          maxDate={addTwoDays(new Date())}
          popperModifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
            },
          }}
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64844 10.3318H20.3475M8.10109 7.54924V3.65234M15.8949 7.54924V3.65234M19.2341 5.87914H4.76184C4.46655 5.87914 4.18335 5.99645 3.97454 6.20525C3.76574 6.41405 3.64844 6.69725 3.64844 6.99254V19.239C3.64844 19.5343 3.76574 19.8175 3.97454 20.0263C4.18335 20.2351 4.46655 20.3524 4.76184 20.3524H19.2341C19.5294 20.3524 19.8126 20.2351 20.0214 20.0263C20.2302 19.8175 20.3475 19.5343 20.3475 19.239V6.99254C20.3475 6.69725 20.2302 6.41405 20.0214 6.20525C19.8126 5.99645 19.5294 5.87914 19.2341 5.87914Z"
                stroke="#212529"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.27054 13.67C7.19671 13.67 7.12591 13.6407 7.07371 13.5885C7.02151 13.5363 6.99219 13.4655 6.99219 13.3916C6.99219 13.3178 7.02151 13.247 7.07371 13.1948C7.12591 13.1426 7.19671 13.1133 7.27054 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.26562 13.67C7.33945 13.67 7.41025 13.6407 7.46245 13.5885C7.51465 13.5363 7.54398 13.4655 7.54398 13.3916C7.54398 13.3178 7.51465 13.247 7.46245 13.1948C7.41025 13.1426 7.33945 13.1133 7.26562 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.27054 17.5645C7.19671 17.5645 7.12591 17.5352 7.07371 17.483C7.02151 17.4308 6.99219 17.36 6.99219 17.2862C6.99219 17.2123 7.02151 17.1415 7.07371 17.0893C7.12591 17.0371 7.19671 17.0078 7.27054 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M7.26562 17.5645C7.33945 17.5645 7.41025 17.5352 7.46245 17.483C7.51465 17.4308 7.54398 17.36 7.54398 17.2862C7.54398 17.2123 7.51465 17.1415 7.46245 17.0893C7.41025 17.0371 7.33945 17.0078 7.26562 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M11.9971 13.67C11.9233 13.67 11.8525 13.6407 11.8003 13.5885C11.7481 13.5363 11.7188 13.4655 11.7188 13.3916C11.7188 13.3178 11.7481 13.247 11.8003 13.1948C11.8525 13.1426 11.9233 13.1133 11.9971 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M12 13.6701C12.0738 13.6701 12.1446 13.6408 12.1968 13.5886C12.249 13.5364 12.2784 13.4656 12.2784 13.3918C12.2784 13.3179 12.249 13.2471 12.1968 13.1949C12.1446 13.1427 12.0738 13.1134 12 13.1134"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M11.9971 17.5645C11.9233 17.5645 11.8525 17.5352 11.8003 17.483C11.7481 17.4308 11.7188 17.36 11.7188 17.2862C11.7188 17.2123 11.7481 17.1415 11.8003 17.0893C11.8525 17.0371 11.9233 17.0078 11.9971 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M12 17.5645C12.0738 17.5645 12.1446 17.5352 12.1968 17.483C12.249 17.4308 12.2784 17.36 12.2784 17.2862C12.2784 17.2123 12.249 17.1415 12.1968 17.0893C12.1446 17.0371 12.0738 17.0078 12 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7315 13.67C16.6577 13.67 16.5869 13.6407 16.5347 13.5885C16.4825 13.5363 16.4531 13.4655 16.4531 13.3916C16.4531 13.3178 16.4825 13.247 16.5347 13.1948C16.5869 13.1426 16.6577 13.1133 16.7315 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7344 13.67C16.8082 13.67 16.879 13.6407 16.9312 13.5885C16.9834 13.5363 17.0127 13.4655 17.0127 13.3916C17.0127 13.3178 16.9834 13.247 16.9312 13.1948C16.879 13.1426 16.8082 13.1133 16.7344 13.1133"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7315 17.5645C16.6577 17.5645 16.5869 17.5352 16.5347 17.483C16.4825 17.4308 16.4531 17.36 16.4531 17.2862C16.4531 17.2123 16.4825 17.1415 16.5347 17.0893C16.5869 17.0371 16.6577 17.0078 16.7315 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
              <path
                d="M16.7344 17.5645C16.8082 17.5645 16.879 17.5352 16.9312 17.483C16.9834 17.4308 17.0127 17.36 17.0127 17.2862C17.0127 17.2123 16.9834 17.1415 16.9312 17.0893C16.879 17.0371 16.8082 17.0078 16.7344 17.0078"
                stroke="#212529"
                strokeWidth="1.25"
              />
            </svg>
          }
          withPortal
        >
          <button
            onClick={() => {
              onChange(new Date());
              mref.current.setOpen(false);
            }}
            id="close-button"
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="35"
                height="35"
                rx="17.5"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="35"
                height="35"
                rx="17.5"
                stroke="#212529"
              />
              <path
                d="M12.375 23.6242L23.625 12.375M12.375 12.3758L23.625 23.625"
                stroke="#212529"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div className="action-buttons">
            <CustomButton
              onClick={() => {
                onChange(new Date());
                mref.current.setOpen(false);
              }}
              name="back"
            />
            <CustomButton
              classnames="primary"
              onClick={() => {
                onChange(selected);
                mref.current.setOpen(false);
              }}
              name="select date"
            />
          </div>
        </DatePicker>
      </div>
    </>
  );
};

export default CustomDatepicker;
